module.exports = __webpack_public_path__ + "static/media/profile_reset.0089dc8b.svg";